// removed by extract-text-webpack-plugin
module.exports = {"submittedSucesBtn":"_1yV_ibr4GngsOweQXBWqGI"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/AlipaySuccessPage/AlipaySuccessPage.scss
 ** module id = 1047
 ** module chunks = 0
 **/